import { Constant } from '@genial/config';
import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { emptyMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { OperationType } from '../../../../contexts/constants';
import { AssetNoticesNormalized } from '../../../AssetNotices';

import { FundsAsset } from '.';

export const fundsSellTableHead: TableHeadItemRecurse[] = [
  { title: 'Produto', flex: 3 },
  { title: 'Resgate total' },
  { title: 'Valor a resgatar', flex: 2 },
  { title: 'IR estimado', flex: 2 },
  { title: 'Valor líq. estimado', flex: 2 },
  { title: 'Cotização', flex: 2 },
  { title: 'Liquidação', flex: 2 },
  { title: '', flex: 2 },
];

export const fundsSellConstants = {
  id: 'funds',
  typeGetterId: 'fundsSell',
  title: 'Fundos',
  operationId: 2,
  operationName: 'Resgatar',
  operationType: 'sell' as OperationType,
  color: 'product.fundos' as ColorTypes.Option,
  principalComponent: FundsAsset,
  tableHead: fundsSellTableHead,
  hideTableHead: false,
  marketStatusSelector: emptyMarketStatusQuery,
  hasFilters: false,
  mountFilters: (): FilterModalTypes.FilterType[] => [],
  hasCategories: false,
  categoriesLabel: '',
  categoriesField: '',
  mountCategories: () => [],
  captions: [],
  groupNotices: false,
  notices: [] as AssetNoticesNormalized[],
  hasRefresher: false,
  unleashFlag: Constant.UnleashFundsSellToggle,
  unleashFlagBatchTicket: Constant.UnleashBasketFundsToggle,
  unleashFlagCustomers: Constant.UnleashCustomersFundsToggle,
} as const;
